/**
 * Lusuku brand colours.
 * ────────────────────────────────────────────────────────────────────────────
 * The two colours the app is actually built out of — the dark ground the hero
 * and the nav are painted in, and the gold that sits on it. Neither existed
 * anywhere in this client as a value: every accent was invented locally, which
 * is how the cart came to wear a red gradient, a red MUI badge, an orange glow
 * and a lime ring, none of them the brand's.
 *
 * Put new accents here rather than inline, and check the pairing before using
 * one. The two below are a deliberate pair: BRAND_GOLD on BRAND_INK measures
 * 9.36:1 either way round, so the same two values work whichever is the fill.
 */

// The dark ground: hero background, nav chrome, and any surface meant to sit
// UNDER content rather than compete with it. 16:1 against a white page.
export const BRAND_INK = "#142427";

// The accent. Light (relative luminance ~0.55), so it belongs ON the ink or as
// an icon and a count — a solid gold shape on a white page measures 1.71:1 and
// has effectively no edge.
export const BRAND_GOLD = "#f5be22";

// Tonal stops, for gradients and pressed states only.
export const BRAND_INK_LIFT = "#1d3438"; // ink, one step lighter
export const BRAND_INK_DEEP = "#0c1719"; // ink, one step darker
export const BRAND_GOLD_DEEP = "#e0a800"; // gold, one step darker
